import { createFileRoute } from '@tanstack/react-router'
import { LoyaltyMembersPage } from '../../../../features/loyalty/members-page'
import { memberSearchSchema } from '../../../../features/loyalty/search'

export const Route = createFileRoute('/_app/loyalty/members/')({
  validateSearch: memberSearchSchema,
  component: LoyaltyMembersPage,
})
